import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import table from './assets/images/t_able.png';

const PhpLesson18 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
      <?php
      $host= 'localhost';
      $user= 'root';
      $password= '';
      $dbname='foliodatabase';
      $dsn ='';

      try{
          $dsn ='mysql:host='.$host.';dbname='.$dbname;
          $pdo= new PDO($dsn,$user,$password);
          $pdo->setAttribute(pdo::ATTR_ERRMODE,PDO::ERRMODE_EXCEPTION);
      }catch(PDOException $e){
          echo 'connection failed:'.$e-> getMessage();
      }
    ?>`
      );

      const code1 = (
        'text',
        `
        <?php
        require 'database.php';

        if(isset($_POST['submit'])){
            $username = trim($_POST['username']);
            $email = trim($_POST['email']);
            $password = $_POST['password'];
            $confirm_password = $_POST['confirm_password'];

            // Check if the passwords match
            if ($password !== $confirm_password) {
                echo "<script>alert('Passwords do not match')</script>";
            } else {
                $hashed_password = password_hash($password, PASSWORD_DEFAULT);

                $sql = "SELECT COUNT(user_name) AS num FROM folio_table WHERE user_name = :username";
                $stmt = $pdo->prepare($sql);
                $stmt->bindValue(':username', $username);
                $stmt->execute();
                $row = $stmt->fetch(PDO::FETCH_ASSOC);

                if($row['num'] == 1){
                    echo "<script>alert('Username already exists')</script>";
                }else{
                    $stmt = $pdo->prepare("INSERT INTO folio_table (user_name, email, password) VALUES (:user_name, :email, :password)");
                    $stmt->bindParam(':user_name', $username);
                    $stmt->bindParam(':email', $email);
                    $stmt->bindParam(':password', $hashed_password);
                    if($stmt->execute()){
                        echo "<script>alert('User created successfully')</script>";
                    }else{
                        echo "An error occurred. Please try again later";
                    }
                }
            }
        }
        ?>

        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Registration Form</title>
        </head>
        <body>
            <center>
                <h2>Create New user</h2>
                <form action="" method="POST">
                    <label for="username">Username:</label>
                    <input type="text" id="username" name="username" required><br><br>

                    <label for="email">Email:</label>
                    <input type="email" id="email" name="email" required><br><br>

                    <label for="password">Password:</label>
                    <input type="password" id="password" name="password" required><br><br>

                    <label for="confirm_password">Confirm Password:</label>
                    <input type="password" id="confirm_password" name="confirm_password" required><br><br>

                    <input type="submit" name="submit" value="Register">
                </form>
            </center>
        </body>
        </html>`
      );

      const code2 = (
        'text',
`<?php
require 'database.php';
?>

<!DOCTYPE html>
<html lang="en">

<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.4/jquery.min.js"></script>
<script src="https://cdn.datatables.net/1.13.6/js/jquery.dataTables.min.js"></script>
<link rel="stylesheet" href="https://cdn.datatables.net/1.13.6/css/jquery.dataTables.min.css" />
<title>Document</title>
<style>
table,
tr,
td,
th {
    border: 1px solid black;
    border-collapse: collapse;
}
</style>
</head>

<body>
<center>
<table id="myTable">
<thead>
<tr>
<th>SERIAL NUMBER</th>
<th>USERNAME</th>
<th>EMAIL</th>
<th>UPDATE</th>
<th>DELETE</th>
</tr>
</thead>
<tbody>

<?php
$num = 1;
$fetch = $pdo->query('SELECT * FROM folio_table');
if($fetch->rowCount() > 0){
while($row = $fetch->fetch(PDO::FETCH_ASSOC)){
$username = $row['user_name'];
$email = $row['email'];
?>

<tr>
<td><?php echo $num++; ?></td>
<td><?php echo $username; ?></td>
<td><?php echo $email; ?></td>
<td>
<a href="update.php?id=
<button>Update</button>
</a>
</td>
<td>
<?php echo
"<a href=\"update.php?id=".$row['info_id']."\">
<button type='button' class='btn'>UPDATE</button>
</a>";
?>
</td>
<td>
<a href="delete.php?id=<?php echo $row['info_id']; ?>">
<button>Delete</button>
</a>
</td>
</tr>
<?php }} ?>
</tbody>

</table>

<button><a href="logout.php">Logout</a></button>

</center>

<script>
let table = new DataTable('#myTable');
</script>
</body>

</html>`
      );


      const code3 = (
        'text',
        `<?php
        require 'database.php';
        $id = "";
        $email = "";
        $username = "";
        $password = "";

        if (isset($_GET["id"])) {
            $id = $_GET["id"];
        }

        $stmt = $pdo->prepare("SELECT * FROM folio_table WHERE info_id = :info_id ");
        $stmt->bindValue(':info_id', $id);
        $stmt->execute();
        $row = $stmt->fetch(PDO::FETCH_ASSOC);
        if($row){
            $username = $row['user_name'];
            $email = $row['email'];
            $password = $row['password'];
        }

        if (isset($_POST['update'])) {
            $name = empty($_POST['username'])? $username : $_POST['username'];
            $email = empty($_POST['email'])? $email : $_POST['email'];
            $password = empty($_POST['password'])? $password : $_POST['password'];
            $hashed_password = password_hash($password, PASSWORD_DEFAULT);

            $stmt = $pdo->prepare("UPDATE folio_table SET user_name = :user_name, email = :email, password = :password WHERE info_id = :info_id");
            $stmt->bindParam(':user_name', $name);
            $stmt->bindParam(':email', $email);
            $stmt->bindParam(':password', $hashed_password);
            $stmt->bindParam(':info_id', $id);

            if ($stmt->execute()) {
                echo "<script>alert('update successful')</script>";
            } else {
                echo "An error occurred. Please try again later";
            }
        }
        ?>

        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Document</title>
        </head>
        <body>
            <center>
            <form action="" method="post"> <!-- Changed action to empty, so the form submits to itself -->
                <label for="Username">Username:</label>
                <input type="text" id="username" value="<?php echo $username; ?>" name="username" required> <br> <br>

                <label for="Email">Email:</label>
                <input type="text" id="email" value="<?php echo $email; ?>" name="email" required> <br> <br>

                <label for="password">Password:</label>
                <input type="password" id="password" value=<?php echo $password; ?> name="password" required> <br> <br>

                <label for="check_password">Check password:</label>
                <input type="password" id="checkpassword" name="checkpassword" required> <!-- Changed id to 'checkpassword' -->

                <br>
                <input name="update" type="submit" value="update">
            </form>
        </center>

        </body>
        </html>
        `
      );

      const code4 = (
        'text',
        `


        <?php
        require 'database.php';
        $id = "";

        if(isset($_GET["id"])){
            $id = $_GET["id"];
        }

        $del = "DELETE FROM folio_table WHERE info_id = '$id' ";
        if($pdo->exec($del)){
            echo '<script>alert("Record deleted successfully")</script>';
            echo '<script>window.location.replace("table.php")</script>';
        }else{
            echo "An error occurred";
        }

        ?>
        `
      );







  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
      <h3><strong>CRUD Illustration</strong></h3>
      <p>In this guide, we'll walk you through the process of creating new user information, updating existing data, and deleting records directly from your webpage, eliminating the need to access your database separately.</p>
      <br/>
      <p>To enhance the functionality of your web application, you need to incorporate a table that facilitates operations like updating and deleting records. For this purpose, you can integrate DataTables, a powerful jQuery plugin, into your project. By including the following links in your HTML document:</p><br/>
      <p>You enable your web application to present data in an organized and interactive table format. DataTables simplifies sorting, searching, and pagination of tabular data, enhancing user experience and efficiency.</p><br/>
      <p>Once integrated, you can create a table element in your HTML to display the dataset you want to manipulate. Utilizing DataTables functionalities, users can easily navigate, filter, and manage the displayed records. Additionally, you can incorporate update and delete buttons within each row of the table to enable users to perform corresponding actions on specific data entries. <br/><br/>
        <strong>N.B: Any name you're given to your file must have a PHP Extension</strong></p>
      <br/><br/>
      </div>

      <div className="alert alert-secondary" role="alert">
       <h4><strong>Table</strong></h4>


       <CopyBlock
        language={"php"}
        text={code2}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />

<p><strong>The code below is contained in a file named Table with a PHP Extension</strong></p>

                      <br/>
                      </div>

        <div className="alert alert-secondary" role="alert">

         <h4><strong>Create</strong></h4>

         <CopyBlock
                        language={"php"}
                        text={code}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />
    <p><strong>This code is contained in a file named database with a PHP extension.</strong></p>
    </div>
    <br/>
    <div className="alert alert-secondary" role="alert">

          <p><strong>The code below is contained in a file named create with a PHP Extension</strong></p>
    <CopyBlock
                        language={"php"}
                        text={code1}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />
                      <br/>

                     <p>The require 'database.php'; code is a PHP directive that tells the PHP interpreter to include the contents of the file named "database.php" at the point where this line is written.

In other words, it imports the code from the "database.php" file into the current PHP script. This allows you to access functions, variables, classes, or any other code defined in the "database.php" file within your current script.</p>
</div>
<br/><br/>

<div className="alert alert-secondary" role="alert">

<h4>Update</h4>

<CopyBlock
                        language={"php"}
                        text={code3}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />
                      <br/>

                      <p><strong>The code is contained in a file named Update with a PHP Extension</strong></p>

                      </div>


                      <div className="alert alert-secondary" role="alert">

<h4>Delete</h4>

<CopyBlock
                        language={"php"}
                        text={code4}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />

<p><strong>The code is contained in a file named Delete with a PHP Extension</strong></p>
</div>

                      <br/>
                      <div className="alert alert-secondary" role="alert">
                        <p><strong>This is what the Table will look like</strong></p>


                      <img src={table} alt="phpmyadim" class="img-fluid mb-4" />
                      <br/>

                      <h4><strong>Summary</strong></h4>
                      <p>Previously, we discussed creating databases and tables on your local host. In these examples, you saw how the database and table are referenced, and all the data in this table resides in your database. Therefore, any updates or deletions made will reflect in the database.</p>
    </div>




    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson18
